import { css } from 'linaria';
import { styled } from 'linaria/react';
import { media } from '../../../media';

export const PageTitleMargin = css`
	margin-bottom: 24px !important;
`;

export const Wrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 303px;
	column-gap: 101px;
	${media.laptop} {
		grid-template-columns: 1fr 243px;
		column-gap: 49px;
	}
	${media.tablet} {
		grid-template-columns: 1fr;
	}
`;

export const StepsMargin = css`
	${media.tablet} {
		margin-top: 40px;
	}
`;
